module.exports = __webpack_public_path__ + "img/sawtooth-wave.62e17abf.svg";